/**
 * Sets the lazy load attribute to the images in the content
 * @param {Element} content
 * @param {number} skipImgCount - The number of images to skip
 */
export const setLazyLoad = (content, skipImgCount = 0) => {
  content.querySelectorAll("img").forEach((e, index) => {
    if (index >= skipImgCount) {
      e.setAttribute("loading", "lazy");
    }
  });
};

/**
 * Removes the lazy load attribute from the images in the content
 * @param {Element} content
 */
export const removeLazyLoad = content => {
  content.querySelectorAll("img").forEach(e => {
    e.removeAttribute("loading");
  });
};
